import '../src/Footer.css';
import logoimg from '../src/image/logo.png';

const Footer = () => {
    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    return (
        <footer id="footer">
            <div className="footer-bg">
                <div className="container footer-content">

                    {/* LOGO SECTION */}
                    <div className="footer-logo-section">
                        <div className="footer-logo-horizontal">
                            <a href='/' alt="indec">
                            <img src={logoimg} alt="indec" /></a>
                        </div>
                    </div>

                    {/* QUICK LINKS */}
                    <div className="footer-links">
                        <h3>Quick Links</h3>
                        <ul>
                            <li><a href="/">What we do</a></li>
                            <li><a href="/who-we-are">Who we are</a></li>
                            <li><a href="/service">Services</a></li>
                            {/* <li><a href="/projects">Projects</a></li> */}
                            <li><a href="/products">Products</a></li>
                            <li><a href="/contact">Contact</a></li>
                        </ul>
                    </div>

                    {/* CONTACT INFO */}
                    <div className="footer-contact">
                        <h3>Contact Us</h3>
                        <p><strong>Email:</strong> <a href="mailto:admin@indectech.in">admin@indectech.in</a></p>
                        <p><strong>Phone:</strong> <a href="tel:+919677710062">+91 96777 10062</a> / <a href="tel:+919952880078">99528 80078</a>   </p>
                        <p><strong>Address:</strong>AK Complex, Aarthi Theatre Road, Dindigul, Tamil Nadu 624001</p>
                    </div>

                    {/* SOCIAL ICONS */}
                    <div className="footer-social">
                        {/* <h3>Follow Us</h3>
                        <div className="social-icons">
                            <a href="#" className="twitter"><i className="bi bi-twitter"></i></a>
                            <a href="#" className="facebook"><i className="bi bi-facebook"></i></a>
                            <a href="#" className="instagram"><i className="bi bi-instagram"></i></a>
                            <a href="#" className="linkedin"><i className="bi bi-linkedin"></i></a>
                        </div> */}
                        <p className='footer-bottom'>© indec {new Date().getFullYear()}, all rights reserved</p>
                    </div>
                </div>

                {/* BACK TO TOP BUTTON */}
                <button className="back-to-top rounded" onClick={scrollToTop} aria-label="Back to top">
                    <i className="bi bi-arrow-up-short"></i>Back to top
                </button>
            </div>
        </footer>
    );
};

export default Footer;
